import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, Instagram, Facebook } from "lucide-react";
import { SITE, CITIES } from "../data/siteData";

export const Footer = () => (
  <footer className="bg-black border-t border-white/10" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-6 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
      <div>
        <img src={SITE.logo} alt="Chinook K9 logo" className="h-14 w-auto mb-5" />
        <p className="text-white/60 text-sm leading-relaxed">
          Certified professional dog training serving Calgary and surrounding communities.
        </p>
        <div className="flex gap-4 mt-5">
          <a href={SITE.instagram} target="_blank" rel="noreferrer" data-testid="footer-instagram" className="text-white/60 hover:text-brand transition-colors" aria-label="Instagram">
            <Instagram size={20} />
          </a>
          <a href={SITE.facebook} target="_blank" rel="noreferrer" data-testid="footer-facebook" className="text-white/60 hover:text-brand transition-colors" aria-label="Facebook">
            <Facebook size={20} />
          </a>
        </div>
      </div>
      <div>
        <h4 className="font-heading font-semibold text-white mb-4 text-sm tracking-widest uppercase">Programs</h4>
        <ul className="space-y-2.5 text-sm">
          <li><Link to="/about" className="text-white/60 hover:text-brand transition-colors" data-testid="footer-about">About Us</Link></li>
          <li><Link to="/programs" className="text-white/60 hover:text-brand transition-colors" data-testid="footer-programs">All Programs</Link></li>
          <li><Link to="/services/board-and-train" className="text-white/60 hover:text-brand transition-colors" data-testid="footer-board-train">Board & Train</Link></li>
          <li><Link to="/services/private-training" className="text-white/60 hover:text-brand transition-colors" data-testid="footer-private">Private Training</Link></li>
          <li><Link to="/virtual-dog-training" className="text-white/60 hover:text-brand transition-colors" data-testid="footer-virtual">Virtual Lessons</Link></li>
          <li><Link to="/services/jumpstart" className="text-white/60 hover:text-brand transition-colors" data-testid="footer-jumpstart">Jumpstart Program</Link></li>
          <li><Link to="/gallery" className="text-white/60 hover:text-brand transition-colors" data-testid="footer-gallery">Gallery</Link></li>
          <li><Link to="/blog" className="text-white/60 hover:text-brand transition-colors" data-testid="footer-blog">Blog</Link></li>
          <li><Link to="/faqs" className="text-white/60 hover:text-brand transition-colors" data-testid="footer-faqs">FAQs</Link></li>
          <li><Link to="/contact" className="text-white/60 hover:text-brand transition-colors" data-testid="footer-contact">Contact Us</Link></li>
        </ul>
      </div>
      <div>
        <h4 className="font-heading font-semibold text-white mb-4 text-sm tracking-widest uppercase">Service Areas</h4>
        <ul className="space-y-2.5 text-sm">
          {CITIES.map((c) => (
            <li key={c.slug}>
              <Link to={`/dog-training/${c.slug}`} className="text-white/60 hover:text-brand transition-colors" data-testid={`footer-city-${c.slug}`}>
                Dog Training {c.name}
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <div>
        <h4 className="font-heading font-semibold text-white mb-4 text-sm tracking-widest uppercase">Contact</h4>
        <ul className="space-y-3 text-sm text-white/60">
          <li className="flex gap-2.5"><MapPin size={16} className="text-brand shrink-0 mt-0.5" /> {SITE.address}</li>
          <li>
            <a href={SITE.phoneHref} className="flex gap-2.5 hover:text-brand transition-colors" data-testid="footer-phone">
              <Phone size={16} className="text-brand shrink-0 mt-0.5" /> {SITE.phone}
            </a>
          </li>
          <li>
            <a href={`mailto:${SITE.email}`} className="flex gap-2.5 hover:text-brand transition-colors" data-testid="footer-email">
              <Mail size={16} className="text-brand shrink-0 mt-0.5" /> {SITE.email}
            </a>
          </li>
          <li className="flex gap-2.5"><Clock size={16} className="text-brand shrink-0 mt-0.5" /> {SITE.hours}</li>
        </ul>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col sm:flex-row justify-between items-center gap-3 text-xs text-white/40">
        <span className="flex items-center gap-4">
          <span>© {new Date().getFullYear()} Chinook K9. All rights reserved.</span>
          <Link to="/admin" className="hover:text-brand transition-colors font-semibold" data-testid="footer-admin-link">Owner Login</Link>
        </span>
        <span className="text-white/40">
          Website Created by{" "}
          <a href="https://www.GregMiceli.com" target="_blank" rel="noreferrer" className="hover:text-brand transition-colors" data-testid="footer-credit-greg">
            www.GregMiceli.com
          </a>{" "}
          powered by{" "}
          <a href="https://www.K9os.app" target="_blank" rel="noreferrer" className="hover:text-brand transition-colors" data-testid="footer-credit-k9os">
            www.K9os.app
          </a>
        </span>
        <span className="flex items-center gap-4">
          <span>10% discount for veterans & first responders, year-round.</span>
        </span>
      </div>
    </div>
  </footer>
);
